(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__bpFlipInit) return;
    window.__bpFlipInit = true;
    const GRID = '.product-grid, .resource-list';
    const ITEM = '.product-grid__item, .resource-list__item';
    let queued = false;
    function layout() {
      queued = false;
      document.querySelectorAll(GRID).forEach((grid) => {
        const items = [...grid.querySelectorAll(ITEM)].filter(
          (el) => el.closest(GRID) === grid && el.offsetParent !== null && el.querySelector('.bp-flip')
        );
        let row = -1, col = 0, lastTop = null;
        items.forEach((el) => {
          const top = Math.round(el.getBoundingClientRect().top + window.scrollY);
          if (lastTop === null || Math.abs(top - lastTop) > 4) { row += 1; col = 0; lastTop = top; } else { col += 1; }
          const back = row >= 1 && (row + col) % 2 === 1;
          el.toggleAttribute('data-bp-back', back);
          el.dataset.bpRow = row;
          el.dataset.bpCol = col;
        });
      });
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(layout); } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue); else queue();
    window.addEventListener('load', queue);
    window.addEventListener('resize', queue);
    new MutationObserver((muts) => {
      if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.(ITEM + ',' + GRID) || n.querySelector?.(ITEM))))) queue();
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
